<template>
  <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5">
    <vs-table :data="payments">
      <template slot="header">
        <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
          <div class="vx-col w-1/3">
            <h6>ข้อมูลค่าธรรมเนียม</h6>
          </div>
          <div class="vx-col w-2/3 flex justify-end m-0 p-0">
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search"
                       @click="onPressedActiveAddPayment()">ค้นหาการชำระเงิน
            </vs-button>
          </div>
        </div>
      </template>
      <!-- ส่วนหัวตาราง -->
      <template slot="thead">
        <vs-th>วันที่ชำระ</vs-th>
        <vs-th>ค่าธรรมเนียม</vs-th>
        <vs-th>เบี้ยปรับ</vs-th>
        <vs-th>ดอกเบี้ย</vs-th>
        <vs-th>เงินต้น</vs-th>
        <vs-th>จัดการ</vs-th>
      </template>

      <!-- แถวข้อมูล -->
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(row, index) in data">
          <vs-td>
            <vs-input type="text" v-model="row.date" class="input w-full"/>
          </vs-td>
          <vs-td>
            <vs-input type="number" v-model="row.fee" class="input w-full"/>
          </vs-td>
          <vs-td>
            <vs-input type="number" v-model="row.penalty" class="input w-full"/>
          </vs-td>
          <vs-td>
            <vs-input type="number" v-model="row.interest" class="input w-full"/>
          </vs-td>
          <vs-td>
            <vs-input type="number" v-model="row.principal" class="input w-full"/>
          </vs-td>
          <vs-td>
            <vs-button color="danger" @click="onRemovePayment(index)">-</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- ปุ่มเพิ่มแถว -->
    <div class="flex justify-end">
      <vs-button color="primary" @click="onAddPayment(null)">เพิ่มการชำระเงิน</vs-button>
    </div>
    <vs-popup
      :active.sync="paymentModal.active"
      title="ค้นหาการชำระเงิน"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider name="วันที่เป็นต้นไป" rules="required" v-slot="{ errors }">
                  <label class="text-sm">วันที่เป็นต้นไป*</label>
                  <flat-pickr :config="configDatePayment" class="w-full" v-model="paymentModal.date"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider name="เลขที่สัญญา" :rules="{ required: true }" v-slot="{ errors }">
                  <label class="text-sm">เลขที่สัญญา*</label>
                  <v-select
                    v-model="paymentModal.contractId"
                    :options="contractOptions"
                    name="contract"
                    :reduce="res => res.value"
                    class="fixed-width-select"
                  />
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptPaymentModel">ตกลง</vs-button>
        <vs-button color="danger" @click="paymentModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import 'flatpickr/dist/themes/dark.css'
import flatPickr from "vue-flatpickr-component";
import moment from "moment/moment";
import vSelect from 'vue-select'
import {createNamespacedHelpers, mapGetters} from "vuex";

const {mapActions: mapAccountingActions} = createNamespacedHelpers('Accounting');

/**
 * @typedef {Object} Payment
 * @property {string} date
 * @property {number} fee
 * @property {number} penalty
 * @property {number} interest
 * @property {number} principal
 */


export default {
  name: "PaymentForm",
  props: {
    /** @type {Payment[]} */
    payments: {type: Array, required: true},
    onAddPayment: {type: Function, required: true},
    onRemovePayment: {type: Function, required: true},
    onClearPayments: {type: Function, required: true}
  },
  components: {flatPickr, vSelect,},
  computed: {
    ...mapGetters({
      contractOptions: "Accounting/contractOptions",
    }),
    configDatePayment() {
      return {
        monthSelectorType: 'static',
        allowInput: true,
        locale: 'th',
        dateFormat: 'd-m-Y',
      }
    },
  },
  data() {
    return {
      paymentModal: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
        contractId: "",
      },
    };
  },
  methods: {
    ...mapAccountingActions(['getPaymentsByContractId', 'getContractOptions']),
    async onPressedActiveAddPayment() {
      const vm = this
      vm.paymentModal.active = true
      vm.paymentModal.date = moment().format('DD-MM-YYYY');
      vm.paymentModal.contractNo = "";
    },
    async onPressedAcceptPaymentModel() {
      const vm = this
      const {getPaymentsByContractId} = vm;
      const date = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentModal.date.trim())
      const results = await getPaymentsByContractId({
        contractId: vm.paymentModal.contractId,
        date
      })

      if(results && results.length > 0) {
        vm.onClearPayments();
        results.forEach(payment => {
          vm.onAddPayment(payment);
        })
      } else {
        this.$vs.notify({
          title: 'ไม่พบข้อมูล',
          text: 'ม่พบข้อมูลการชำระเงินตามเงื่อนไขที่ระบุ',
          color: 'warning',
          time: 5000 // แสดง 8 วินาที
        })
      }
      vm.paymentModal.active = false
    },
  },
  async created() {
    const vm = this

    const {getContractOptions} = vm
    if (vm.contractOptions.length === 0) {
      await getContractOptions();
      vm.$vs.loading();
      setTimeout(() => {
        vm.created = true
        vm.$vs.loading.close();
      }, 500);
    }
  },

}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.custom-popup .vs-popup {
  width: 800px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
